module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_1_f90065ad.46a3a9e1.woff";